module.exports = __webpack_public_path__ + "img/15.e2a863e4.jpg";